<template>
  <div>
    <div v-if="error" class="danger darken-4 p3 mt3 mx3 white">
      {{ getReferencelabel(error.code) }}
    </div>
    <GenerateForm :form="form" :data="data" :save-action="saveData" :delete-action="openConfirmModel" />
    <Modal v-if="showModal">
      <template #body>
        <div class="col-12 flex flex-column items-center justify-center white-bg modal-qrcode-dimensions">
          <span class="h4n bold mb3">{{ getReferencelabel("DELETE_OTHER_TRAVELLERS") }}</span>
          <div class="flex col-12">
            <Button reference="NO" class="inline-block col-6 mt2 mx1" btn-color="blue" :action="closeConfirmModel" />
            <Button reference="YES" class="inline-block col-6 mt2 mx1" btn-color="red" :action="deleteContact" />
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>

import { reactive, ref, provide } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { getUser, createContact, updateContact, updateUser } from '@/mixins/requests';
import GenerateForm from '@/components/common/GenerateForm';
import { getReferencelabel, isInImpersonateModeNotification } from '@/mixins/utils';
import Modal from '@/components/blocks/Modal';
import Button from '@/components/elements/Button';

export default {
  components: { GenerateForm, Modal, Button },
  setup () {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const user = { ...store.state.user };

    const data = reactive({ ...(store.state.contacts.find(u => u.uuid === route.params.uuid) || {}) });
    const form = require('@/configs/profileForm.json');

    form.flat().forEach(field => {
      if (field.optionsByFile) field.options = require(`@/configs/${field.optionsByFile}`);
    });

    const error = ref(null);
    const showModal = ref(false);
    provide('showModal', showModal);

    async function saveData () {
      if (isInImpersonateModeNotification()) {
        return;
      }
      store.commit('setLoading', true);
      const response = data.uuid ? await updateContact(data) : await createContact(data, store.state.user.uuid);
      if (response?.success) {
        // Sync user data
        await getUser();

        router.replace({ name: 'MyContacts' });
      } else if (response?.message) {
        error.value = response;
      }

      store.commit('setLoading', false);
      // if (user) {
      //  this.user = user;
      // }
    }

    async function deleteContact () {
      if (isInImpersonateModeNotification()) {
        return;
      }
      store.commit('setLoading', true);
      user.contacts = user.contacts.filter(c => c.uuid !== data.uuid);
      const response = await updateUser(user);
      if (response.success) {
        // Sync user data
        await getUser();

        router.replace({ name: 'MyContacts' });
      }

      store.commit('setLoading', false);
    }

    const openConfirmModel = () => {
      showModal.value = true;
    };

    const closeConfirmModel = () => {
      showModal.value = false;
    };

    return { data, form, error, showModal, getReferencelabel, saveData, openConfirmModel, deleteContact, closeConfirmModel };
  }
};
</script>

<style>
.input-height {
  height: 50px;
}

</style>
